import { VersionDescriptor } from '@feedyou/schema'
import { Option, toSelectOption } from '../../../../../../../../lib/options'

export const getVersionOptions = (
  versions: VersionDescriptor[] | undefined,
  deployedVersion: string | undefined | null,
  latestVersion: string | undefined | null
): Option[] => {
  if (!versions) {
    return []
  }

  const getOptionLabel = (version: string) =>
    `${version} ${getLabelSuffix(version, deployedVersion, latestVersion)}`

  return versions?.map(({ version }) => toSelectOption(version, getOptionLabel(version)))
}

const getLabelSuffix = (
  version: string,
  deployedVersion: string | undefined | null,
  latestVersion: string | undefined | null
) => {
  if (version === deployedVersion && version === latestVersion && version !== 'latest') {
    return '(latest & deployed)'
  }

  if (version === latestVersion && version !== 'latest') {
    return '(latest)'
  }

  if (version === deployedVersion) {
    return '(deployed)'
  }

  return ''
}
